const columns = [

  {
    title: '细项名称',
    dataIndex: 'optionName',
    key: 'optionName',
  },
  {
    title: '达标情况',
    dataIndex: 'standardSituation',
    key: 'standardSituation',
    align: 'center',
  },
  // {
  //   title: '点评内容',
  //   dataIndex: 'commentContent',
  //   key: 'commentContent',
  //   align: 'center',
  //   width: '30%'
  // },
  // {
  //   title: '反馈内容',
  //   dataIndex: 'feedbackContent',
  //   key: 'feedbackContent',
  //   align: 'center',
  //   width: '30%'
  // }
];

export default columns
